import React, { createContext, useContext, useState } from 'react';

const MapStateContext = createContext();

export const useMapState = () => {
  const context = useContext(MapStateContext);
  if (!context) {
    throw new Error('useMapState must be used within a MapStateProvider');
  }
  return context;
};

export const MapStateProvider = ({ children }) => {
  const [mapLayer, setMapLayer] = useState([]);
  const [isVisibleData, setIsVisibleData] = useState(false);
  const [isVisibleArea, setIsVisibleArea] = useState(false);
  const [zoomToLayerId, setZoomToLayerId] = useState(null);

  const deleteDataset = (id) => {
    console.log('Deleting layer with id:', id);
    setMapLayer(prevLayers => {
      const newLayers = prevLayers.filter(item => item.id !== id);
      console.log('Updated layers after delete:', newLayers);
      return newLayers;
    });
  };

  const handleVisible = (id) => {
    console.log('Toggling visibility for id:', id);
    setMapLayer(prevLayers => {
      const data = [...prevLayers];
      const index = data.findIndex(x => x.id === id);
      if (index !== -1) {
        data[index].visible = !data[index].visible;
        console.log('Layer visibility toggled:', data[index]);
      }
      return data;
    });
  };

  const setZoomToMap = (layerId) => {
    console.log('Zoom to layer:', layerId);
    setZoomToLayerId(layerId);
    setTimeout(() => setZoomToLayerId(null), 100);
  };

  const handleOpacity = (layerId, opacity) => {
    console.log('Setting opacity for layer:', layerId, opacity);
    setMapLayer(prevLayers => {
      const data = [...prevLayers];
      const index = data.findIndex(x => x.id === layerId);
      if (index !== -1) {
        data[index].opacity = opacity;
        console.log('Layer opacity updated:', data[index]);
      }
      return data;
    });
  };

  const addLayer = (layer) => {
    console.log('Adding layer:', layer);
    setMapLayer(prevLayers => [...prevLayers, layer]);
  };

  const openCatalog = () => {
    setIsVisibleData(true);
  };

  const closeCatalog = () => {
    setIsVisibleData(false);
  };

  const openArea = () => {
    setIsVisibleArea(true);
  };

  const closeArea = () => {
    setIsVisibleArea(false);
  };

  const value = {
    // State
    mapLayer,
    isVisibleData,
    isVisibleArea,
    zoomToLayerId,
    
    // Actions
    setMapLayer,
    addLayer,
    deleteDataset,
    handleVisible,
    setZoomToMap,
    handleOpacity,
    openCatalog,
    closeCatalog,
    openArea,
    closeArea,
  };

  return (
    <MapStateContext.Provider value={value}>
      {children}
    </MapStateContext.Provider>
  );
};